import type { Item } from "../common";

export enum InsightsFromAIFilterField {
    CONTENT_TYPES = "AI_INSIGHT_CONTENT_TYPES",
    BRAND = "AI_INSIGHT_BRAND",
    BROWSE_NODE = "AI_INSIGHT_BROWSE_NODE",
}

export type InsightFromAIFieldSelections = {
    [key in InsightsFromAIFilterField]: Item[];
};
export type InsightFromAIFilterOptions = {
    [key in InsightsFromAIFilterField]: Item[];
};
